import { render, staticRenderFns } from "./CardColumnsSection.vue?vue&type=template&id=434b9e2d&scoped=true&"
import script from "./CardColumnsSection.vue?vue&type=script&lang=js&"
export * from "./CardColumnsSection.vue?vue&type=script&lang=js&"
import style0 from "./CardColumnsSection.vue?vue&type=style&index=0&id=434b9e2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434b9e2d",
  null
  
)

export default component.exports